import {Tabs} from "antd";
import {useTranslation} from "react-i18next";
import AccountVerify_2 from "./component/accountVerify";
import "./css/style.css"
import VerificationHistory_2 from "./component/verificationHistory";
import {useState} from "react";

export default function AccountVerificationV2_2(props) {
    const { t } = useTranslation();
    const [currentTab, setCurrentTab] = useState(0);

    const tabItems = [
        {
            key: "accountVerification",
            label: t("accountVerification.accountVerification"),
            children: (
                <AccountVerify_2
                    {...props}
                />
            )
        },
        {
            key: "uploadHistory",
            label: t("accountVerification.uploadHistory"),
            children: (
                <VerificationHistory_2 {...props} currentTab={currentTab}/>
            ),
        },
    ]

    return (
        <div id={"accountVerificationV2"}>
            <Tabs
                defaultActiveKey={tabItems[0].key}
                items={tabItems}
                className={"tabColour"}
                onChange={(key) => setCurrentTab(key)}
            />
        </div>
    )
}